import { render } from "./Infor.vue?vue&type=template&id=3d533d5c&scoped=true"
import script from "./Infor.vue?vue&type=script&lang=js"
export * from "./Infor.vue?vue&type=script&lang=js"

import "./Infor.vue?vue&type=style&index=0&id=3d533d5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d533d5c"

export default script